//import * as Backbone from 'backbone';
var Backbone = require('backbone');
import * as _ from 'underscore';

import config from '../../common/config';

export var Model = Backbone.Model.extend({
    errors: [],
    bust: function () {
        return this.mdUSERID + '?bust=' + new Date().getTime();
    },
        
    initialize: function () {
        var that = this;

    },
    getMenuStatus: function () {
        //true enable menu
        //false disable menu

        var ret = !this.validateNoBackbone(this.attributes);

        //if true, check address
        if (ret) {
            if (this.attributes.Address_lat == 0 || this.attributes.Address_lat == 0 ||
                this.attributes.Address_lat == null || this.attributes.Address_lat == null) {
                ret = false;
            }
        }
        return ret;
    },
    validateNoBackbone: function (attrs) {
        this.errors = [];

        if (!attrs.Name) {
            this.errors.push({ name: 'custom_inputName', message: resources.X100324 });
        }

        if (!attrs.Email) {
            this.errors.push({ name: 'custom_inputEmail', message: resources.X100324 });
        }

        //if (!attrs.SecondName) {
        //    this.errors.push({ name: 'custom_inputSecondName', message: resources.X100324 });
        //}

        if (!attrs.Address01) {
            this.errors.push({ name: 'custom_inputAddress', message: resources.X100324 });
        }

        if (!attrs.ContactPersonName) {
            this.errors.push({ name: 'custom_inputContactperson_Name', message: resources.X100324 });
        }

        if (!attrs.ContactPersonPhone) {
            this.errors.push({ name: 'custom_inputContactperson_Phone', message: resources.X100324 });
        }
        if (!attrs.ContactPersonEmail) {
            this.errors.push({ name: 'custom_inputContactperson_Email', message: resources.X100324 });
        }

        /*
        var checkCompanyRegistration = false;
        switch (attrs.Organisation) {
            case 0 :  checkCompanyRegistration = false; break;
            case 1 :  checkCompanyRegistration = true; break;
            case 2 :  checkCompanyRegistration = false; break;
        }
        if (checkCompanyRegistration) {
            if (!attrs.CompanyRegistration) {
                this.errors.push({ name: 'custom_inputCompanyRegistration', message: resources.X100324 });
            }
        
            //^(\d){8}$
            var validate_CompanyRegistration = app.entities.collections.publicConfigSubscriptionValidate.where( {Name : 'register_inputCompanyRegistration'});
            if (validate_CompanyRegistration && validate_CompanyRegistration.length > 0) {
                var re = new RegExp(validate_CompanyRegistration[0].attributes.Value, 'g');
                if(attrs.CompanyRegistration.match(re) == null) {
                    this.errors.push({ name: 'custom_inputCompanyRegistration', message: validate_CompanyRegistration[0].attributes.Error });
                }
            }
        }

        var checkAttPerson = false;
        switch (attrs.Organisation) {
            case 0 :  checkAttPerson = false; break;
            case 1 :  checkAttPerson = true; break;
            case 2 :  checkAttPerson = true; break;
        }
        if (checkAttPerson) {
            if (!attrs.AttPerson) {
                this.errors.push({ name: 'custom_inputAttPerson', message: resources.X100324 });
            }
        }*/

        if (this.errors.length > 0) {
            return true
        }
        else {
            return false;
        }
        //return errors.length > 0 ? errors : false, 
    },
    // different url for read, update
    "sync": function (method, model, options) {
        if ((method == 'read')  && (options.tmpModel != undefined) && (options.tmpModel.Method == 'GetEmailUsed')) {
            options.url =  config.webApiUrl() + '/api/custom/route01/-1?Email=' + options.tmpModel.Value;
        }
        else if (method == 'read') {

            //var now = new Date();

            //now.setHours(0);
            //now.setMinutes(0);
            //now.setSeconds(1);

            //var utcDateTime = now.getUTCFullYear().toString() + '-' +
            //    (now.getUTCMonth() + 1) + '-' +
            //    now.getUTCDate().toString() + ' ' +
            //    now.getUTCHours() + ':' + now.getUTCMinutes() + ':' + now.getUTCSeconds();

            //options.url = config.webApiUrl() + '/api/custom/-1?AuthUserId=' + config.authUserId() + '&UtcDateTime=' + utcDateTime + '&CultureName=' + config.cultureName();
            options.url = config.webApiUrl() + '/api/custom/-1?AuthUserId=' + config.authUserId();
        }
        //else if (method == 'delete') {
        //    options.url = config.webApiUrl() + '/api/custom/' + model.attributes.id + '?mdUSERID=' + config.authUserId();
        //}
        else if (method == 'update') {
            options.url = config.webApiUrl() + '/api/custom/' + model.attributes.id + '?AuthUserId=' + config.authUserId();
        }
        else if (method == 'create') {
            options.url = config.webApiUrl() + '/api/custom/-1?AuthUserId=' + config.authUserId();
        }
        else {
            options.url = '';
        }

        var m = Backbone.sync(method, model, options);

        return m;
    },
    save: function (attributes, options) {
        //options.success = this.successOnSave;
        //options.error = this.errorOnSave;

        Backbone.Model.prototype.save.call(this, attributes, options);
    },
    successOnSave: function (model, response) {
        model = response;
    },
    errorOnSave: function (model, response) {
        alert("FEJL");
    }
});

    